import type { Product } from "@typings/product/product";

export const getSubtotal = (cartItems: Product[]): number =>
  cartItems.reduce(
    (acc, { configuration }) => acc + configuration.price * configuration.quantity,
    0
  );

export const getTotal = (cart: Product[], discount: number, shippingCost: number): number =>
  getSubtotal(cart) - discount + shippingCost;
